import styled from "styled-components/macro";
import { device } from "../../device";

export const StyledPlansContainer = styled.div`
  width: 100%;
  padding: 16px 40px;
  @media ${device.tablet} {
    padding: 0.5rem 0;
  }
`;

export const StyledHeader = styled.header`
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 0px;
  h2 {
    font-size: 32px;
    font-style: normal;
    font-weight: 600;
    line-height: 48px;
    letter-spacing: 0em;
    color: #575e68;
    margin-bottom: 16px;
    margin-top: 10px;
  }
  p {
    font-style: normal;
    font-weight: normal;
    font-size: 16px;
    line-height: 100%;
    color: #575e68;
  }
  @media ${device.mobileL} {
    h2 {
      font-size: 24px;
      line-height: 40px;
      margin-bottom: 14px;
    }
    p {
      font-size: 14px;
    }
  }
`;

export const StyledCardsList = styled.ul`
  max-width: 100%;
  list-style: none;
  justify-content: center;
  gap: 25px;
  padding: 0px;
  margin: 20px auto;
  flex-wrap: wrap;
  display: grid;
  grid-template-columns: repeat(3,1fr);
  @media ${device.laptop} {
    grid-template-columns: repeat(1,1fr);
  }
  
  li {
    flex-grow: 1;
    flex-shrink: 1;
    flex-basis: 0;
  }
  @media ${device.laptop} {
    margin: 30px auto;
    gap: 1rem;
  }
  @media ${device.tablet} {
    margin: 20px auto;
    gap: 1rem;
  }
`;

export const StyledCardContainer = styled.div`
  min-width: 250px;
  height: 355px;
  flex-grow: 1;
  position: relative;

  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 2rem;
  width: 100%;

  background: #ffffff;
  border: 1px solid #ebedee;
  border-radius: 8px;
  @media ${device.laptop} {
    padding: 1.5rem;
  }
  @media ${device.tablet} {
    padding: 1rem;
    min-width: 210px;
    height: 250px;
    display: grid;
    grid-template-columns: 1.25fr .75fr;
    button {
        grid-column: 1 / 3;
    }
  }
`;

export const StyledBadge = styled.p`
  position: absolute;
  top: 8px;
  right: 27px;

  padding: 4px 8px;

  background: #008060;
  border-radius: 4px;

  font-weight: 600;
  font-size: 12px;
  line-height: 18px;
  color: #f4f6f8;

  margin: 10px 0px;

  @media ${device.laptop} {
    top: 5px;
    right: 24px;

    font-size: 10px;
    line-height: 16px;

    margin: 8px 0px;
  }
`;

export const StyledCardHeader = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 0px;
`;

export const StyledCardTitle = styled.p`
  text-transform: uppercase;
  font-size: 26px;
  line-height: 100%;

  color: #575e68;

  margin-bottom: 16px;
`;
export const StyledCardPrice = styled.div`
  display: flex;
  align-items: baseline;
  font-weight: bold;
`;
export const StyledPrice = styled.span`
  font-weight: 600;
  font-size: 40px;
  line-height: 40px;

  color: #111111;

  margin: 0 8px;
  @media ${device.laptop} {
    font-size: 28px;
    line-height: 28px;
  }
  @media ${device.tablet} {
    font-size: 24px;
    line-height: 24px;
    margin: 0 4px;
  }
`;
export const StyledMonth = styled.span`
  font-size: 14px;
  line-height: 21px;
  @media ${device.laptop} {
    font-size: 10px;
    line-height: 16px;
  }
  @media ${device.tablet}{
    font-size: 16px;
  }
`;
export const StyledCrossedPrice = styled.span`
  font-weight: 600;
  font-size: 30px;
  line-height: 40px;

  color: #575e68;
  opacity: 0.5;

  text-decoration: line-through;

  @media ${device.laptop} {
    font-size: 14px;
    line-height: 28px;
  }
  @media ${device.tablet} {
    font-size: 12px;
    line-height: 24px;
  }
`;

export const StyledCardBilled = styled.p`
  font-size: 14px;
  line-height: 21px;

  color: #575e68;
  opacity: 0.5;

  margin: 8px 0;
  @media ${device.laptop} {
    font-size: 12px;
    margin-bottom: 0;
  }
`;

export const StyledCardSessions = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: 0px;
  margin: 40px 0;
  font-weight: 600;
  font-size: 16px;
  line-height: 100%;
  color: #575e68;
  span {
    margin-right: 10px;
  }
  @media ${device.laptop} {
    margin: 1rem 0;
    font-size: 14px;
  }
  @media ${device.tablet} {
    font-size: 18px;
    font-weight: normal;
    display: inline;
    span {
      margin-right: 5px;
    }
  }
`;

export const StyledCardButton = styled.button`
  &:hover {
    cursor: ${(props) => (props.disabled ? "not-allowed" : "pointer")};
  }
  width: 100%;

  background: ${(props) => (props.disabled ? "#939DD6" : "#6270c6")};
  border: 1px solid #939dd6;
  border-radius: 4px;
  padding: 16px 0;

  text-transform: uppercase;
  font-weight: 600;
  font-size: 16px;
  line-height: 100%;
  text-align: center;

  color: #fcfcfd;

  @media ${device.laptop} {
    font-size: 14px;
    padding: 12px 0;
  }

  @media ${device.tablet} {
    font-size: 12px;
    padding: 10px 0;
  }
`;

export const StyledCouponForm = styled.form`
  margin-bottom: 42px;
  font-size: 16px;
  color: #575e68;
  input {
    border: 1px solid #dddddd;
    border-radius: 4px;
    padding: 10px 16px;
  }
  button {
    font-size: 16px;
    font-weight: 600;
    color: #fcfcfd;
    background: #6270c6;
    border: 1px solid #939dd6;
    border-radius: 4px;
    margin: 10px;
    padding: 10px 21px;
    cursor: pointer;
  }
`;

export const StyledGotACoupon = styled.p`
  margin-bottom: 42px;
  font-size: 16px;
  color: #575e68;
  cursor: pointer;
`;

export const Row = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    gap: .25rem;
`;

export const CancelLink = styled.span`
    color: #575e68;
    cursor: pointer;
    height: 0;
    transform: translateY(10px);
    @media ${device.tablet}{
        transform: unset;
        grid-column: 1/3;
    }
`

export const StyledGridWrapper = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr; 
  grid-template-rows: 400px;
`;

export const CancelLeft = styled.div`
    border-radius: 0px 4px 4px 0px;
    background: #ffffff;
    padding: 1rem 1.6rem 2.2rem 1.6rem;
    line-height:24px;
`

export const CancelLeftInner = styled.div`
    width: calc(100% - 120px);
    margin: auto;
    text-align: left;
`

export const CancelRight = styled.div`
    background: linear-gradient(110.71deg, #262F69 -3.16%, #6270C6 107.12%);
    border-radius: 0px 4px 4px 0px;
    display: flex;
    align-items: center;
`

export const StyledCancelPlan = styled.div`
    margin-top:4rem;
`

export const StyledCardHorizontalContainer = styled.div`
    margin-top: 1rem auto 0 auto;
    display:flex;
    gap: 1rem;
    justify-content: center;
    width:80%;
`

export const MidBox = styled.div`
    background: #ffffff;
    a {
      z-index: 1;
      cursor: pointer;
    }
`